export default __webpack_public_path__ + "imgs/beTogether03.91f6051.jpeg";